var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashcan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1477",
    x: 1,
    y: 4,
    width: 10,
    height: 9,
    fill: "#3886F7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1478",
    y: 1,
    width: 12,
    height: 2,
    fill: "#3886F7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19",
    x: 4,
    width: 4,
    height: 1,
    fill: "#3886F7"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashcan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trashcan.999a713ea1c477c4019ad78e91fdf86b.svg";